import { z } from 'zod';

/**
 * One navbar entry. `key` and `icon` are plain strings so a client that does not
 * know a newer key/icon can ignore the item instead of failing to load app state.
 */
export const NavbarItemSchema = z.object({
  key: z.string(),
  name: z.string(),
  icon: z.string(),
  ordinal: z.number(),
  enabled: z.boolean(),
});

export type NavbarItem = z.infer<typeof NavbarItemSchema>;
